import { render } from "./CatalogLastLog.vue?vue&type=template&id=4ef2f129"
import script from "./CatalogLastLog.vue?vue&type=script&lang=js"
export * from "./CatalogLastLog.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__